ValidationEngine = App.loadClass 'core::ValidationEngine'
SelectBox = App.loadClass 'core::SelectBox'
accounting = App.loadClass 'bower::accounting/accounting'
ConfirmDialog = App.loadClass 'core::ConfirmDialog'

class exports.RuppOrdersDialogDiscountsHandler extends Handler

    init: () ->
        @layoutUrl = 'backend/grower/rupp-orders/load-layout-discounts'
        @layoutSelector = '#orders_steps_container'
        @loadLayout()

        @dataLoaded = false


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        ths = this

        @data = response

        # Set the accounting money format
        accounting.settings.currency.format = {
            pos: '%s%v',
            neg: '(%s%v)',
            zero: '%s%v'
        }

        # Sales Rep name
        debugLog('afterLoadLayout: sales_rep')
        debugLog(sales_rep)
        sales_rep = @taffyObjects['sales_reps'](
            'id':
                '==': @parent.saveData['sales_rep_fk']
        ).select('name')
        debugLog('afterLoadLayout: sales_rep')
        debugLog(sales_rep)
        $('#sales_rep').text(sales_rep)

        # List of customer names
        custnames = ''
        for key, cust of @parent.saveData['customers']
            customer = @taffyObjects['customers'](
                'id':
                    '==': cust.users_id
            ).select('name')
            custnames += ', ' if custnames isnt ''
            custnames += customer

        $('#customers').text(custnames)

        # Crop
        crop = @taffyObjects['crops'](
            'id':
                '==': @parent.saveData['crops_id']
        ).select('name')
        $('#crop').text(crop)

        # Avg cost/ac calculation
        $('#avg_population').bind 'change', () ->
            $(this).val( ths.parseNumber($(this).val()) )
            ths.calculateTotals()

        # Add new discount
        @discount_id = 0
        $('#btn_add_discount').bind 'click', () ->
            discount_id = $(this).data('id')
            $(this).removeData('id')
            discount_id = ths.discount_id if not discount_id?

            data = $('.add-disc-tmpl').render()
            data = $($.parseHTML(data))
            discounts = [['Volume Discount', 'Volume Discount'], ['Early Order Discount', 'Early Order Discount'], ['Other Discount', 'Other Discount']]
            SelectBox.render discounts, data.find('.sel_disc_amnt')

            data.find('.order-data').attr('data-dynamic-btn', '#btn_add_discount')
            data.find('.order-data').attr('data-dynamic-id', discount_id)
            data.find('.btn_disc_delete').attr('data-dynamic-id', discount_id)

            data.find('.disc_units').hide()

            ths.discount_id = parseInt(discount_id) + 1

            data.appendTo('.discounts_container')

            ths.hideUsedDiscounts data.find('.sel_disc_amnt')

        # Delete discount
        $('.disc-outer-container').delegate '.btn_disc_delete', 'click', () ->
            ths.parent.deleteFormData('discounts', $(this).data('dynamic-id'))
            $(this).closest('.disc-row').remove()
            ths.calculateTotals()
            ths.hideUsedDiscounts()

        # Change discount
        $('.discounts_container').delegate '.sel_disc_amnt', 'change', () =>
            @calculateTotals()
            @hideUsedDiscounts()

        $('.discounts_container').delegate '.txt_disc_amnt', 'change', () =>
            @calculateTotals()

        $('.discounts_container').delegate '.txt_disc_units', 'change', () =>
            @calculateTotals()

        if @parent.editable
            # Handle validation
            @validator = new ValidationEngine()

            @validator.makeFormValidator 'discounts', '#discounts_container', '#discounts_errors', (valid) =>
                @parent.saveFormData()
                @parent.save('Saving order...') if valid

            @validator.registerRule
                selector: '.validate-moneyIsPositive',
                text: '%s must be greater than 0',
                func: (elem) ->
                    val = accounting.unformat(elem.text())
                    return (not val or ($.isNumeric(val) and parseFloat(val) > 0) )

            @validator.registerRule
                selector: '.validate-volumeUnits'
                text: 'The total number of discounted units must not exceed the total number of units'
                func: (elem) ->
                    count = 0
                    for input in $('.disc-row')
                        if $(input).find('.sel_disc_amnt').val() is "Volume Discount"
                            count += parseInt($(input).find('.txt_disc_units').val())
                    return (not $(total_units).text() or count <= parseInt($(total_units).text()))

        $('.jdf-discount').hide()
        $('#payment_types_id').bind 'change', () ->
            id = $(this).val()

            if not id
                $('#early_pay_discounts_id').val('').prop('disabled', 'disabled')
                $('#early_pay_percent').val('').prop('disabled', 'disabled')
                return

            can_early_pay = ths.taffyObjects['payment_types'](
                id:
                    '==': id
            ).select('can_early_pay')[0]

            if can_early_pay
                $('.early-pay-discount').show()
                $('#net_total_with').show()
                $('#net_total_body').show()
                $('.early-pay-type').text('Early Pay')
                $('#early_pay_discounts_id').prop('disabled', false)
                $('#early_pay_percent').prop('disabled', false)

                # Early pay date select
                early_pay_discounts = ths.taffyObjects['early_pay_discounts']().select('id', 'name')
                SelectBox.render early_pay_discounts, $('#early_pay_discounts_id')

                ths.removeExpiredEarlyPayDiscounts()
            else
                $('#early_pay_discounts_id').val('')
                $('.early-pay-discount').hide()
                $('#net_total_with').hide()
                $('#net_total_body').hide()

            ths.calculateTotals()

        $('#early_pay_percent').bind 'change', () =>
            @calculateTotals()

        @parent.loadFormData()

        @parent.dialog.find('.message_writer').message_writer( autoHide: false )

    # https://www.pivotaltracker.com/story/show/102197954
    hideUsedDiscounts: (discount) =>
        allDiscounts = $('.discounts_container .sel_disc_amnt')

        if discount?
            discounts = [discount]
        else
            discounts = allDiscounts

        for discount in discounts
            discount = $(discount)
            discount.find('option').show()
            for globalDiscount in allDiscounts
                globalDiscount = $(globalDiscount)

                continue if globalDiscount.is(discount)

                optionToHide = globalDiscount.val()

                if optionToHide isnt 'Volume Discount'
                    discount.find("option[value='#{optionToHide}']").hide()


    afterLoadData: () ->
        ths = this

        @dataLoaded = true

        # Change early pay discount
        $('#early_pay_discounts_id').bind 'change', () =>
            $('#early_pay_percent').val('')
            @calculateTotals()

        if not @parent.saveData['address2']
            $('[name="address2"]').next().remove()

        @calculateTotals()

        $('#btn_orders_next').prop('disabled', false)

    removeExpiredEarlyPayDiscounts: () =>
        selected = $('#early_pay_discounts_id').val()
        whenOrderPlaced = moment(@parent.saveData.order_date)
        $('#early_pay_discounts_id option').each (i, el) =>
            el = $(el)
            date = moment(el.text()).add(1, 'days')

            if el.attr('value') isnt selected and whenOrderPlaced.diff(date) > 0
                el.remove()


    calculateTotals: () ->
        ths = this

        return if not @dataLoaded

        @parent.saveFormData()

        $.post 'backend/grower/rupp-orders/new-pricing-summary', JSON.stringify(@parent.saveData), (data) =>
            data = $.parseJSON data

            # Set basic summary information
            $(@layoutSelector).find('#avg_cost_per_acre').text(accounting.formatMoney(data.avg_net_cost_per_acre))
            $(@layoutSelector).find('#total_units').text(data.total_units)
            $(@layoutSelector).find('#avg_unit_cost').text(accounting.formatMoney(data.avg_gross_unit_cost))
            $(@layoutSelector).find('#subtotal').text(accounting.formatMoney(data.subtotal))
            $(@layoutSelector).find('#net_total').text(accounting.formatMoney(data.net_total))

            if data.early_pay_percent
                $(@layoutSelector).find('#early_pay_percent').val(data.early_pay_percent)
            else
                $(@layoutSelector).find('#early_pay_percent').val('')

            if data.early_pay_amnt?
                $(@layoutSelector).find('#early_amnt').text(accounting.formatMoney(data.early_pay_amnt))
            else
                $(@layoutSelector).find('#early_amnt').text('')

            if data.jdf_percent?
                $(@layoutSelector).find('#jdf_percent').text(data.jdf_percent + '%')
            else
                $(@layoutSelector).find('#jdf_percent').text('')

            if data.jdf_amnt?
                $(@layoutSelector).find('#jdf_amnt').text(accounting.formatMoney(data.jdf_amnt))
            else
                $(@layoutSelector).find('#jdf_amnt').text('')

            $(@layoutSelector).find('#final_total').text(accounting.formatMoney(data.net_total_with_early_pay))
            $(@layoutSelector).find('#avg_cost_per_acre').text(accounting.formatMoney(data.avg_net_cost_per_acre))

            # Remove all volume discounts
            $(@layoutSelector).find('.discounts_container div.volume-discount-container').remove()

            # Unset all manual discounts from having been updated
            $(@layoutSelector).find('.discounts_container select.sel_disc_amnt').attr('data-needs-update', true)
            $(@layoutSelector).find('.discounts_container .disc-amnt').text('')

            if not @parent.editable
                $(@layoutSelector).find(".btn-disc-delete").prop('disabled', true)

            # Set pricing for each discount
            for discount in data.discounts

                amnt = accounting.formatMoney(-1 * discount.total_amnt)

                # Discount is a manually selected discount
                sel = $(@layoutSelector).find('.discounts_container select.sel_disc_amnt[data-needs-update]')[0]
                sel = $(sel)
                sel.closest('.disc-row').find('.txt_disc_amnt').val(discount.amnt)
                sel.closest('.disc-row').find('.txt_disc_units').val(discount.units)
                sel.closest('.disc-row').find('.disc_amnt').text(amnt)

                if discount.name is 'Volume Discount'
                    sel.closest('.disc-row').find('.disc_units').show()
                else
                    sel.closest('.disc-row').find('.disc_units').hide()

                sel.removeAttr('data-needs-update')


    parseNumber: (val) ->
        return Number(val.replace(/[^0-9\.]+/g, ''))
